<template>
  <div class="member-list-wrap">
    <ImmersionHeader
      ref="ImmersionHeader"
      :title="$t('FoodC_update_QQlM_iHYO')"
      :titleStyle="titleStyle"
      :isShowBackBtn="true"
      leftIconClassName="icon-v3_outlined_back"
      :blackTheme="true"
      @BackCK="goBackFn"
    />
    <!-- 顶部间距 -->
    <div :style="{ 'padding-top': headerHeight + 'px' }"></div>
    <!-- 列表 -->
    <div
      v-if="transNationalMemberList && transNationalMemberList.length"
      class="member-list-content"
    >
      <div v-for="item in transNationalMemberList" :key="item.country" class="info">
        <div class="text">
          <h5 v-if="item.countryName" class="title">{{ item.countryName }}</h5>
          <p v-if="item.status" class="main_text">{{ subTextList[item.status] }}</p>
          <p v-if="item.validDays && item.validDays > 0" class="sub_text">
            {{ $t('FoodC_cancellation_ChTe_NHPP', { days: item.validDays } /*有效期剩余xx天*/) }}
          </p>
        </div>
        <div v-if="item.status" class="btn">
          <span v-if="item.status === 1" class="dis_btn">{{
            $t('FoodC_cancellation_ivLi_DstK' /*订阅已关闭*/)
          }}</span>
          <go-button v-else type="secondary" size="small" @click="cancelSubscription(item)">{{
            $t('FoodC_cancellation_JZXv_OcQW' /*取消订阅*/)
          }}</go-button>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-popup v-model="isShowPop" :close-on-click-overlay="false">
      <div class="pop-box">
        <div class="head-img"></div>
        <div class="content">
          <h5 class="title">
            {{ $t('FoodC_cancellation_dfmf_HEyK', { conuntry: currentItem.countryName || '' }) }}
          </h5>
          <go-button class="pBtn" type="secondary" size="medium" @click="cancelPack">{{
            gettext('确认')
          }}</go-button>
          <go-button class="pBtn" type="secondary" size="medium" @click="hidePop">
            {{ gettext('取消') }}
          </go-button>
        </div>
      </div>
    </van-popup>
    <LoadingMask v-if="loading" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { Popup } from 'vant'
import '@/go-design-ui.js'
import LoadingMask from '@/components/loading/loading-mask.vue'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import mixin from '@/page/member/mixins.js'
import { getMembershipDetail, getUnsubscribeMembership } from '@/api/member/index.js'

Vue.use(Popup)

export default {
  components: {
    ImmersionHeader,
    LoadingMask,
  },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      titleStyle: {
        color: '#000000',
        alpha: 1,
      },
      headerHeight: 0,
      subTextList: {
        1: this.$t('FoodC_cancellation_GzWi_eKHb'), // 未订阅(已取消)
        2: this.$t('FoodC_cancellation_kNom_uYlR'), // 订阅中
        3: this.$t('FoodC_cancellation_hxiG_guHC'), // 已暂停
      },
      isShowPop: false, // 弹窗显示状态
      currentItem: {}, // 用于存储当前操作的item
      pageInfo: {}, // 会员详情数据
    }
  },
  computed: {
    ...mapState(['urlNoSubscribe']),
  },
  mounted() {
    this.headerHeight = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0
  },
  methods: {
    ...mapMutations(['SET_TRANSNATIONAL_INFO']),
    goBackFn() {
      this.$router.back()
    },
    cancelSubscription(item) {
      this.isShowPop = true
      this.currentItem = item
    },
    hidePop() {
      this.isShowPop = false
      this.currentItem = {}
    },
    // 会员取消订阅
    async cancelPack() {
      this.loading = true
      this.isShowPop = false
      let res = {}
      try {
        res = await getUnsubscribeMembership({
          poiCountryCode: this.currentItem?.country,
        })
      } catch {}

      this.currentItem = {}
      this.loading = false
      if (res?.errno === 0) {
        const toast1 = this.$createToast({
          txt: this.$t('FoodC_pause_aidJ_DeYv'),
          time: 1500,
          type: 'warn',
          mask: false,
        })
        toast1.show()
        // 重新获取会员详情，更新列表数据
        this.getDetail()
      } else {
        this.$createToast({
          type: 'warn',
          time: 2000,
          txt: res.errmsg,
        }).show()
      }
    },
    // 获取会员详情
    async getDetail() {
      this.loading = true
      let res = {}
      try {
        res = await getMembershipDetail({ noSubscribe: this.urlNoSubscribe })
      } catch {}

      this.loading = false
      if (res?.errno === 0) {
        this.pageInfo = res?.data || {}
        // 更新跨国信息
        this.SET_TRANSNATIONAL_INFO({
          transNationalInfo: this.pageInfo?.transNationalInfo || {},
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member-list-wrap {
  background: #fff;
  min-height: 100vh;
}
.member-list-content {
  clear: both;
  padding-top: 40px;
  .info {
    margin-bottom: 16px;
    padding: 32px 40px;
    display: flex;
    justify-content: space-between;
    .title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 36px;
      line-height: 44px;
      letter-spacing: normal;
      color: #0b0b0d;
    }
    .main_text {
      padding-top: 8px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      font-weight: normal;
      line-height: 36px;
      letter-spacing: normal;
      color: #0b0b0d;
    }
    .sub_text {
      padding-top: 8px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      font-weight: normal;
      line-height: 36px;
      letter-spacing: normal;
      color: #89898c;
    }
  }
  .btn {
    margin-left: 24px;
    // min-width: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    .dis_btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      line-height: 36px;
      text-align: center;
      letter-spacing: normal;
      color: #89898c;
      padding: 0 32px;
    }
  }
}

.van-popup {
  background: none;
}
.pop-box {
  width: 590px;
  .head-img {
    width: 100%;
    height: 180px;
    background: url('../imgs/head-img.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    z-index: 1;
  }
  .content {
    padding: 180px 40px 32px 40px;
    background: #fff;
    border-radius: 40px;
    position: relative;
    left: 0;
    top: -180px;
    .title {
      padding-top: 42px;
      padding-bottom: 24px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 40px;
      line-height: 56px;
      letter-spacing: normal;
      color: #0b0b0d;
      word-wrap: break-word;
    }
    .pBtn {
      margin-top: 20px;
    }
  }
}
</style>
